// Origins allowed to hand this iframe its auth data via postMessage.
// Set per deploy target in .env.production / .env.dev as a comma-separated list.
const FALLBACK_PARENT_ORIGINS = ['https://dinoconnect.de', 'https://visu.dinoconnect.de']

const configuredOrigins = (import.meta.env.VITE_TRUSTED_PARENT_ORIGINS ?? '')
  .split(',')
  .map((origin) => origin.trim())
  .filter(Boolean)

export const TRUSTED_PARENT_ORIGINS = import.meta.env.DEV
  ? ['http://localhost:3000', 'http://localhost:5173']
  : configuredOrigins.length > 0
    ? configuredOrigins
    : FALLBACK_PARENT_ORIGINS
